import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { Control } from "react-hook-form";
import type { CommunicationFormValues } from "../communicationFormSchema";

interface CommunicationDetailsProps {
  control: Control<CommunicationFormValues>;
  isSubmitting: boolean;
}

export const CommunicationDetails: React.FC<CommunicationDetailsProps> = ({ control, isSubmitting }) => (
  <FormField
    control={control}
    name="body"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Communication Details</FormLabel>
        <FormControl>
          <Textarea
            placeholder="Describe what was discussed, key points, outcomes, next steps..."
            className="min-h-[120px] resize-y"
            {...field}
            disabled={isSubmitting}
          />
        </FormControl>
        <FormDescription>
          Detailed notes about the communication content and outcomes
        </FormDescription>
        <FormMessage />
      </FormItem>
    )}
  />
);
